import { Link } from "react-router-dom";
import GroupTile from "./GroupTile";
import type { ProcessGroup } from "../../../../types/types";
import {
  useIsAdmin,
  useGetPageFromPath,
  useWorkScheduleIdOnCurrentPage,
} from "utils/customHooks/genericHooks";
import { GroupTileMoreMenu } from "./GroupTileMoreMenu";
import { useGroupTilesFilterState } from "./groupTilesUtils";
import { IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useSelector } from "store/useSelector";

type GroupTilesProps = {
  processGroups: ProcessGroup[];
  tileWidth?: number;
  lastKnownGroupTilesCounts: {
    [groupSortIdx: number]: { value: string; label: string };
  };
  customerKey: string;
};

const GroupTiles = ({
  processGroups,
  tileWidth,
  lastKnownGroupTilesCounts,
  customerKey,
}: GroupTilesProps) => {
  const workScheduleId = useWorkScheduleIdOnCurrentPage();
  const { isAllWorkSchedulesPage } = useGetPageFromPath();
  const isAdminUser = useIsAdmin();
  return (
    <>
      {processGroups.map(
        ({
          groupSortIdx,
          summaryGroup,
          processes,
          shortName,
          longName,
          isIdleUntagged,
          count,
          showCountNotMetricOnGroupTile,
          callStart,
        }) => {
          return (
            <div className="groupTiles" key={`panel-${summaryGroup}`}>
              <div className="tile-container">
                <Link
                  to={`/${customerKey}/dashboard/${summaryGroup}?workSchedule=${
                    isAllWorkSchedulesPage
                      ? processes[0]?.workScheduleConfig?.id
                      : workScheduleId
                  }`}
                >
                  <GroupTile
                    tileWidth={tileWidth}
                    groupSortIdx={groupSortIdx}
                    shortName={shortName}
                    output={
                      lastKnownGroupTilesCounts[groupSortIdx]
                        ? lastKnownGroupTilesCounts[groupSortIdx].value
                        : count
                    }
                    outputLabel={
                      lastKnownGroupTilesCounts[groupSortIdx]
                        ? lastKnownGroupTilesCounts[groupSortIdx].label
                        : "parts"
                    }
                    isIdleUntagged={isIdleUntagged}
                    showCountNotMetricOnGroupTile={
                      showCountNotMetricOnGroupTile
                    }
                    callStart={callStart}
                    processes={processes}
                    summaryGroup={summaryGroup}
                  />
                </Link>
                {isAdminUser ? (
                  <GroupTileMoreMenu
                    {...{
                      summaryGroup,
                      workScheduleId,
                      customerKey,
                    }}
                  />
                ) : null}
                {isAllWorkSchedulesPage ? (
                  <RemoveGroupFromFilterStateButton {...{ longName }} />
                ) : null}
              </div>
            </div>
          );
        }
      )}
    </>
  );
};
export default GroupTiles;

function RemoveGroupFromFilterStateButton({ longName }: { longName: string }) {
  const [, setGroupTilesFilterState] = useGroupTilesFilterState();
  const allGroups = useSelector(state => state.legacy.allGroups);
  const allGroupLongNames = allGroups.map(g => g.longName);
  return (
    <IconButton
      onClick={() => {
        setGroupTilesFilterState(prev => ({
          ...prev,
          selectedGroupNames: (prev.selectedGroupNames.length === 0
            ? // if all are visible but none are selected, select all first (otherwise, nothing happens)
              allGroupLongNames
            : prev.selectedGroupNames
          ).filter(n => n !== longName),
        }));
      }}
      size="small"
      style={{ position: "absolute", top: 0, right: 0 }}
    >
      <Close />
    </IconButton>
  );
}
